/**
 * Utility functions for QA testing mode
 */

/**
 * Valid EPS status values for QA testing
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const VALID_EPS_STATUSES = [
  'active',
  'blockedbycustomer',
  'blockedbyissuer',
  'blockedbypartner',
] as const;

/**
 * Maps normalized status strings to canonical EPS status values
 */
const EPS_STATUS_MAP: Record<string, string> = {
  active: 'Active',
  blockedbycustomer: 'BlockedByCustomer',
  blockedbyissuer: 'BlockedByIssuer',
  blockedbypartner: 'BlockedByPartner',
};

/**
 * Parses and validates a QA card EPS status parameter from URL
 * @param {string | null} statusParam - The status parameter from URL search params
 * @returns {string | null} The canonical EPS status value, or null if invalid
 */
export function parseQACardEpsStatus(statusParam: string | null): string | null {
  if (!statusParam) return null;

  const normalizedStatus = statusParam.toLowerCase().trim();

  if (VALID_EPS_STATUSES.includes(normalizedStatus as (typeof VALID_EPS_STATUSES)[number])) {
    return EPS_STATUS_MAP[normalizedStatus] ?? null;
  }

  console.warn(
    `Invalid QA card-eps-status parameter: ${statusParam}. Valid options: ${VALID_EPS_STATUSES.join(', ')}`
  );
  return null;
}

const QA_CARD_STATUSES = [
  'none',
  'start-verification',
  'verification-required',
  'continue-verification',
  'ready-to-order',
  'verification-progress',
  'rejected',
  'final-rejected',
  'card-declined',
  'preparing-delivery',
  'on-way',
  'inactive',
  'active',
] as const;

type QACardStatus = (typeof QA_CARD_STATUSES)[number];

const QA_CARD_STATUS_MAP = {
  none: 'start-verification',
  'start-verification': 'start-verification',
  'verification-required': 'start-verification',
  'continue-verification': 'continue-verification',
  'ready-to-order': 'ready-to-order',
  'verification-progress': 'verification-progress',
  rejected: 'rejected',
  'final-rejected': 'final-rejected',
  'card-declined': 'card-declined',
  'preparing-delivery': 'preparing-delivery',
  'on-way': 'on-way',
  inactive: 'inactive',
  active: null,
} as const satisfies Record<QACardStatus, string | null>;

function isQACardStatus(status: string): status is QACardStatus {
  return QA_CARD_STATUSES.includes(status as QACardStatus);
}

/** `false` means the param is absent or not a known status, so the account state is used. */
export function parseQACardStatus(statusParam: string | null) {
  if (!statusParam) return false;

  const normalizedStatus = statusParam.toLowerCase().trim();
  if (isQACardStatus(normalizedStatus)) return QA_CARD_STATUS_MAP[normalizedStatus];

  console.warn(
    `Invalid QA card status parameter: ${statusParam}. Valid options: ${QA_CARD_STATUSES.join(', ')}`
  );
  return false;
}
